import { render, staticRenderFns } from "./AddProductModal.vue?vue&type=template&id=71265af1&scoped=true"
import script from "./AddProductModal.vue?vue&type=script&lang=js"
export * from "./AddProductModal.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./AddProductModal.vue?vue&type=style&index=0&id=71265af1&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "71265af1",
  null
  ,true
)

export default component.exports